import { useState } from 'react';
import { clearTokens, storedAccessToken } from './api';
import { Login } from './Login';
import { Fleet } from './Fleet';
import { HubDetail } from './HubDetail';

export function App() {
  const [signedIn, setSignedIn] = useState(storedAccessToken() !== null);
  const [openHubId, setOpenHubId] = useState<string | null>(null);

  if (!signedIn) {
    return <Login onSignedIn={() => setSignedIn(true)} />;
  }

  return (
    <div className="wrap">
      <header className="top">
        <h1>eeyoo fleet</h1>
        <span className="spacer" />
        <button
          onClick={() => {
            clearTokens();
            setOpenHubId(null);
            setSignedIn(false);
          }}
        >
          sign out
        </button>
      </header>

      {openHubId
        ? <HubDetail hubId={openHubId} onBack={() => setOpenHubId(null)} />
        : <Fleet onOpen={setOpenHubId} />}
    </div>
  );
}
